import bronze from "../assets/images/pricing-logo/bronze.png";
import copper from "../assets/images/pricing-logo/copper.png";
import gold from "../assets/images/pricing-logo/gold.png";
import platinum from "../assets/images/pricing-logo/platinum.png";
import silver from "../assets/images/pricing-logo/silver.png";
import titanium from "../assets/images/pricing-logo/titanium.png";

export const YearlyPlan = [
  {
    plan: "Bronze",
    icon: bronze,
    yearprice: 0,
    monthprice: 0,
    yearfacilities: [
      "Projects Creation : 1 ",
      "Project Collaboration Request : 1",
    ],
    monthfacilities: [
      "Projects Creation : 1 ",
      "Project Collaboration Request : 1",
    ],
  },
  {
    plan: "Copper",
    icon: copper,
    yearprice: 100,
    monthprice: 10,
    yearfacilities: [
      "Projects Creation : 6",
      "Project Collaboration Request : 6",
      "Unbuild Competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
    ],
    monthfacilities: [
      "Projects Creation : 6",
      "Project Collaboration Request : 6",
      "Unbuild Competition Participation : Permitted",
      "Access to BIM Linrary ",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
    ],
  },

  {
    plan: "Silver",
    icon: silver,
    yearprice: 1000,
    monthprice: 100,
    yearfacilities: [
      "Projects Creation : 100/Unlimited",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book ",
    ],
    monthfacilities: [
      "Projects Creation : 100/Unlimited ",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book",
    ],
  },
  {
    plan: "Gold",
    icon: gold,
    yearprice: 3000,
    monthprice: 3600,
    yearfacilities: [
      "Projects Creation : 100/Unlimited",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book",
      "Random website Spotlight Selection",
      "Guarantee Magazine Advertising 1/2 Page",
    ],
    monthfacilities: [
      "Projects Creation : 100/Unlimited",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book",
      "Random website Spotlight Selection",
      "Guarantee Magazine Advertising 1/2 Page",
    ],
  },
  {
    plan: "Platinum",
    icon: platinum,
    yearprice: 4500,
    monthprice: 5400,
    yearfacilities: [
      "Projects Creation : 100/Unlimited",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book",
      "Random website Spotlight Selection",
      "Guarantee Magazine Advertising Full Page",
    ],
    monthfacilities: [
      "Projects Creation : 100/Unlimited",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book",
      "Random website Spotlight Selection",
      "Guarantee Magazine Advertising Full Page",
    ],
  },
  {
    plan: "Titanium",
    icon: titanium,
    yearprice: 6000,
    monthprice: 7200,
    yearfacilities: [
      "Projects Creation : 100/Unlimited ",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book",
      "Random website Spotlight Selection",
      "Guarantee Magazine Advertising Spread",
    ],
    monthfacilities: [
      "Projects Creation : 100/Unlimited",
      "Project Collaboration Request : 100/Unlimited",
      "Unbuild Competition Participation : Permitted",
      "Build competition Participation : Permitted",
      "Access to BIM Linrary",
      "Random Magazine spotlight Selection",
      "Digital Magazine Access",
      "Physical Magazine Access",
      "Potentially featured in Annual Excellence Book",
      "Random website Spotlight Selection",
      "Guarantee Magazine Advertising Spread",
    ],
  },
];
